import { Component, EventEmitter, forwardRef, Injector, Input, OnInit, Output } from '@angular/core';
import { DialogService } from '../dialog/dialog.service';
import { FingerprintCaptureComponent } from '../fingerprint-capture/fingerprint-capture.component';
import { DialogModalSize } from '../dialog/dialog-ref';
import { BaseService } from '../../shared/services/base.service';
import { NG_VALUE_ACCESSOR } from '@angular/forms';
import { FingerprintQuestion } from '../form/models/question-fingerprint.model';
import { FingerprintService } from '../../services/fingerprint.service';


@Component({
    selector: 'app-fingerprint',
    templateUrl: './fingerprint.component.html',
    styleUrls: ['./fingerprint.component.scss'],
    providers: [
        {
            provide: NG_VALUE_ACCESSOR,
            useExisting: forwardRef(() => FingerprintComponent),
            multi: true
        }
    ],
    standalone: false
})
export class FingerprintComponent implements OnInit {
  @Input() question: FingerprintQuestion;
    @Input('value') _value: any;
    @Output() valueChange = new EventEmitter<any>();
    propagateChange = (_: any) => { };
    onTouched: any = () => { };

  public dialogService: DialogService;
  public baseService: BaseService;
  private previousImage: string;

  constructor(
    public injector: Injector,
    private fingerprintService: FingerprintService
  ){
    if (injector != undefined && injector.get != undefined) {
      this.dialogService = injector.get(DialogService);
      this.baseService = injector.get(BaseService);
    }
  }

  ngOnInit(): void {
      const isDisplayImage: boolean = this?.question?.display_image;
      if (this.question.formAction === 'MODIFY' && isDisplayImage && this.value != undefined && this.value != "") {
        this.fingerprintService.getData(this.value).subscribe({
          next: (response: any) => {
            console.log("getData response:", response);
            this.previousImage = response.imageBase64;
          },
          error: (err) => {
            console.log("Error fetching fingerprint data:", err)
          }
        });
      }
  }
  
  openFingerprintCapture(): void {
    let obj = {
      title: 'Fingerprint Capture',
      size: DialogModalSize.Sm,
      className: "modal-sm"
    };
    this.dialogService.open(FingerprintCaptureComponent, obj).afterClosed.subscribe(data => {
      if (data == undefined || data == null) {
        return;
      }
      console.log("Popup open for fingerprint!", data);
      // data["fingerprint"] = data.id;
      this.value = data;  // This will update the value in the parent component
      this.valueChange.emit(this.value);
    }, err => {
      console.log("Popup cannot open for fingerprint!", err);
    })
  }
  
  get value(): any {
    return this._value;
  }

  set value(val) {
    this._value = val;
    this.propagateChange(val);
    this.onTouched();
  }

  writeValue(value) {
    if (value) {
      this.value = value;
      this.setvalueForUpdate(this.value);
    }
    this.propagateChange(value);
  }

  setvalueForUpdate(value){
    if (value) {
      this.value = value;
    }
  }
  registerOnChange(fn: any) {
    this.propagateChange = fn;
  }
  registerOnTouched(fn: any) {
    this.onTouched = fn;
  }

}
